import { LinearProgress, Tooltip, Typography } from "@mui/material";
import { Box } from "@mui/system";

const mapOverviewData = (apiData, type) => {
  // //console.log("mapOverviewData", apiData, type);

  switch (type) {
    case "task_overview":
      return {
        completed: apiData.completed_tasks,
        pending: apiData.pending_tasks,
        percentage: apiData.percentage,
        total: apiData.total_tasks,
      };
    case "issue_overview":
      return {
        completed: apiData.completed_issues,
        pending: apiData.pending_issues,
        percentage: apiData.percentage,
        total: apiData.total_issues,
      };
    case "milestones_overview":
      return {
        completed: apiData.completed_milestones,
        pending: apiData.pending_milestones,
        percentage: apiData.percentage,
        total: apiData.total_milestones,
      };
    default:
      return { completed: 0, pending: 0, percentage: 0, total: 0 };
  }
};

export const renderOverviewCell = (params, type) => {
  const overviewData = mapOverviewData(params.value || params, type);
  // //console.log("mapOverviewData_params_value  1  :", overviewData);
  return (
    <Tooltip
      title={
        <Box p={1}>
          <Typography variant="body2">
            Completed: {overviewData.completed}
          </Typography>
          <Typography variant="body2">
            Pending: {overviewData.pending}
          </Typography>
          <Typography variant="body2">Total:{overviewData.total}</Typography>
          <Typography variant="body2">
            Progress: {overviewData.percentage}%
          </Typography>
        </Box>
      }
      arrow
    >
      <Box width="100%" display="flex" alignItems="center" gap={1}>
        <Typography variant="body2">{overviewData.completed}</Typography>
        <Box width="60%">
          <LinearProgress
            completed={overviewData.completed}
            pending={overviewData.pending}
            percentage={overviewData.percentage}
            variant="determinate"
            value={overviewData.percentage}
            sx={{
              height: 10,
              borderRadius: 5,
              backgroundColor: "var(--header-bg-color)",
              "& .MuiLinearProgress-bar": {
                backgroundColor:
                  overviewData.percentage > 50 ? "rgb(3, 229, 93)" : "gray",
              },
            }}
          />
        </Box>
        <Typography variant="body2">{overviewData.total}</Typography>
      </Box>
    </Tooltip>
  );
};
